import {
  prepareCategoryFilters,
  prepareLocationFilters,
  prepareRoomsFilters,
  prepareStatusFilters,
} from './prepareFilters';
import { prepareOffers } from './prepareOffers';

import { IOffersHistoryListingData } from '../../../types/offerHistory';
import { EDealType } from '../../../types/dealType';
import {
  IOfferHistoryResponseDesktopV4
} from "../../../repositories/valuation-offer-history/entities/offer_history/OfferHistoryResponseDesktopV4";

export const prepareOffersHistory = (
  res: IOfferHistoryResponseDesktopV4,
  dealType: EDealType,
): IOffersHistoryListingData => {
  const offers: IOffersHistoryListingData['offers'] = prepareOffers(res.offers, dealType);
  const statusFilters = prepareStatusFilters(res.statusCounts, dealType);
  const roomsFilters = prepareRoomsFilters(res.roomCounts);
  const locationFilters = prepareLocationFilters(res.locations);
  const categoriesFilters = prepareCategoryFilters(res.categories);

  return {
    offers,
    roomsFilters,
    statusFilters,
    locationFilters,
    totalCount: res.totalCount,
    activeFiltersValues: res.activeFiltersValues,
    categoriesFilters,
  };
};
